import { Cell, CellWithHierarchy } from '@pelckmans/elementis/components/table';
import { MaterialIcon } from '../../../../../../components/MaterialIcon';
import { useTranslation } from 'react-i18next';
import { TocNodeRowHeader, ScorableItemRowHeader as ScorableItemRowHeaderType } from '../../../hooks/useTableData';
import { useContext } from 'react';
import { HorizontalScrollContext } from '../../../../../context/HorizontalScrollContextProvider';

export interface ScorableItemRowHeaderProps {
  scorableItem: ScorableItemRowHeaderType;
  level: TocNodeRowHeader['level'];
}

export default function ScorableItemRowHeader({ level, scorableItem }: ScorableItemRowHeaderProps) {
  const { t } = useTranslation();
  const { horizontalScroll } = useContext(HorizontalScrollContext);

  return (
    <CellWithHierarchy
      hierarchyProps={{
        level,
      }}
      sticky={horizontalScroll}
    >
      <Cell.Text
        title={scorableItem.title}
        subTitleBot={t(
          `PAGES.RESULTS.PER_STUDENT.TABLE.SCORABLE_ITEM.TYPE.${scorableItem.scorableItemType.toUpperCase()}`,
        )}
        startAdornment={
          <MaterialIcon
            materialType={scorableItem.materialType}
            contentType={scorableItem.contentType}
            className="scorable-item__image"
          />
        }
      />
    </CellWithHierarchy>
  );
}
